<template>
  <a
    class="d-tracking-link"
    @click="trackEvent"
  >
    <slot />
  </a>
</template>

<script>
import Vue from 'vue';
import Window from '@d-shared/utils/window';

export default {
  props: {
    trackingModals: {
      type: Object,
      default: null,
    },
    url: {
      type: String,
      required: true,
    },
  },
  methods: {
    trackEvent() {
      if (!!this.trackingModals) {
        Vue.prototype.trackingHandler.trackEvent(
          this.trackingModals.modalId,
          this.trackingModals.eventName,
        );
      }

      Window.goTo(this.url);
    },
  },
};
</script>
